import web3 from './web3';
const address = '0x10e3defe9515975626663adeb6221a2166c71a3b'
const compiledTokenCreator = require('./build/TokenCreator.json')
const abi = JSON.parse(compiledTokenCreator.interface)

const instance = new web3.eth.Contract(
    abi, address
   
)

export default instance;